<div class="pt-4 px-4">
    <span class="text-lg">{{ 'selectEntity' | transloco: { COUNT: features().length } }}</span>
    <div
        class="flex flex-col overflow-auto gap-2"
        [style.max-height.px]="maxContainerHeight()">
        @for (item of featuresWithEntityId(); track item.entityId) {
            <div
                class="flex flex-row gap-2 cursor-pointer p-2 rounded-lg"
                [class.bg-custom-light-blue]="selectedEntityIds().has(item.entityId)"
                (click)="toggle(item.entityId)">
                <div class="self-center">
                    <app-checkbox
                        [checkboxState]="
                            selectedEntityIds().has(item.entityId) ? CheckboxState.CHECKED : CheckboxState.UNCHECKED
                        " />
                </div>

                <div class="flex flex-col">
                    <div>
                        <span [class.text-custom-blue]="selectedEntityIds().has(item.entityId)">
                            {{ item.feature.properties['layerName'] }}
                        </span>
                    </div>

                    <div>
                        <span [class.text-custom-blue]="selectedEntityIds().has(item.entityId)">
                            {{ item.feature.properties['businessIdentifier'] }}
                        </span>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="flex justify-end pt-2">
        <app-button
            [icon]="['fas', 'check']"
            [iconSize]="'sm'"
            [label]="'select' | transloco"
            (click)="confirmSelection()" />
    </div>
</div>
